'use strict';

import { Company } from '../Company';
import { Entity } from '../Entity';
import { Plan } from '../Plan';
import { User } from './User';

import { UserCommissionScheduleBandCollection } from '../../Collections/User/UserCommissionScheduleBandCollection';
import { UserCommission } from './UserCommission';
import { UserCommissionScheduleBand } from './UserCommissionScheduleBand';

import { Utilities } from '../../Utilities/Utilities';

export class UserCommissionSchedule extends Entity {
  protected id: number;
  protected commission: UserCommission;
  protected advance: number;
  protected states: [];
  protected ageMin: number;
  protected ageMax: number;
  protected dateMin: Date;
  protected dateMax: Date;
  protected type: string;
  protected name: string;
  protected livesMax: number;
  protected writtenAs: string;
  protected calculateOn: string;

  protected bands: UserCommissionScheduleBandCollection;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;
    this.advance = data.advance;
    this.states = data.states;
    this.name = data.name;
    this.ageMin = data.ageMin;
    this.ageMax = data.ageMax;
    this.dateMin = data.dateMin;
    this.dateMax = data.dateMax;
    this.type = data.type;
    this.livesMax = data.livesMax;
    this.writtenAs = data.writtenAs;
    this.calculateOn = data.calculateOn;

    if (data.dateMin) {
      const dateMin = Utilities.dateTimeStringToDate(data.dateMin);
      this.dateMin = dateMin;
    }

    if (data.dateMax) {
      const dateMax = Utilities.dateTimeStringToDate(data.dateMax);
      this.dateMax = dateMax;
    }

    if (data.commission) {
      const commission = new UserCommission();
      commission.hydrate(data.commission);

      this.commission = commission;
    }

    if (data.bands) {
      const bands = new UserCommissionScheduleBandCollection();

      data.bands.forEach((singleData) => {
        const band = new UserCommissionScheduleBand();
        band.hydrate(singleData);

        bands.addItem(band);
      });

      this.bands = bands;
    }
  }

  public getId() {
    return this.id;
  }

  public getCommission() {
    return this.commission;
  }

  public getAdvance() {
    return this.advance;
  }

  public getName() {
    return this.name;
  }

  public getStates() {
    return this.states;
  }

  public getAgeMin() {
    return this.ageMin;
  }

  public getAgeMax() {
    return this.ageMax;
  }

  public getDateMin() {
    return this.dateMin;
  }

  public getDateMax() {
    return this.dateMax;
  }

  public getLivesMax() {
    return this.livesMax;
  }

  public getWrittenAs() {
    return this.writtenAs;
  }

  public getCalculateOn() {
    return this.calculateOn;
  }

  public getType() {
    return this.type;
  }

  public getBands() {
    return this.bands;
  }
}
